import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Participant } from '@/interfaces/Participant'
import { cn } from '@/lib/utils'

type Reliability = NonNullable<Participant['vatPayerReliability']>

const config: Record<Reliability, { label: string; tone: string; hint: string | null }> = {
  reliable: {
    label: 'Spolehlivý plátce',
    tone: 'bg-success-bg text-success',
    hint: null,
  },
  notReliable: {
    label: 'Nespolehlivý plátce',
    tone: 'bg-danger-bg text-danger',
    hint: 'Podle registru DPH jde o nespolehlivého plátce. Při platbě mu můžete ručit za jeho DPH.',
  },
  unknown: {
    label: 'Spolehlivost neověřena',
    tone: 'bg-neutral-bg text-muted-foreground',
    hint: 'Registr DPH stav nevrátil. Kontakt nejspíš už není plátcem DPH nebo ukončil činnost.',
  },
}

/** Tlumený odznak spolehlivosti plátce DPH (jen v detailu, v seznamu jen u nespolehlivých). */
export const VatPayerReliability = ({ participant, className }: { participant: Participant; className?: string }) => {
  const reliability = participant.vatPayerReliability
  if (!reliability || !config[reliability]) return null
  const { label, tone, hint } = config[reliability]

  const badge = (
    <span
      className={cn(
        'inline-flex h-5 items-center gap-1.5 rounded-full px-2 text-xs font-medium whitespace-nowrap',
        tone,
        className,
      )}
    >
      <span className="size-1.5 rounded-full bg-current opacity-80" aria-hidden />
      {label}
    </span>
  )

  if (!hint) return badge

  return (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent className="max-w-64">
        <p>{hint}</p>
      </TooltipContent>
    </Tooltip>
  )
}
